define('models/pixelEmail',["T1", "T1Model"], function (T1, T1Model) {
  T1.Models.PixelEmail = T1Model.extend({
    url: "pixel_bundles/email"
  });
  return T1.Models.PixelEmail;
});
